import { isNotDefined } from '@sgme/fp';

import { initiateCheckCashByTradeCapture } from '@/store/cash/api';
import { selectCashTile } from '@/store/cash/selectors/tile.ts';
import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { duplicateTile } from '@/store/tiles/slice.ts';

// this listener call trade capture after a duplicate tile
// @see esp-listener for ESP price subscription after duplicate
export const registerDuplicateCashTradeCaptureListenersForCash = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: duplicateTile,
    effect: async (action, api) => {
      const state = api.getState();

      const sourceTile = selectCashTile(state, action.payload.sourceTileId);

      if (isNotDefined(sourceTile)) {
        return;
      }

      const newTileId = action.payload.newTileId;

      // For Forward and NDF, pass maturityDate: undefined so that trade capture uses
      // maturityDateTenor as maturityDateString and resolves the tenor to the correct
      // date for the duplicated tile — rather than inheriting the already-resolved date
      // from the source tile. Type narrowing per branch is required to avoid a TypeScript
      // union-spread error on sourceTile.properties.
      if (sourceTile.type === 'FxFwd') {
        api.dispatch(
          initiateCheckCashByTradeCapture({
            tileId: newTileId,
            type: sourceTile.type,
            properties: { ...sourceTile.properties, maturityDate: undefined },
          }),
        );
        return;
      }

      if (sourceTile.type === 'FxNdf') {
        api.dispatch(
          initiateCheckCashByTradeCapture({
            tileId: newTileId,
            type: sourceTile.type,
            properties: { ...sourceTile.properties, maturityDate: undefined },
          }),
        );
        return;
      }

      // FxSpot — maturity is always SP, no tenor resolution needed
      api.dispatch(
        initiateCheckCashByTradeCapture({
          ...sourceTile,
          tileId: newTileId,
        }),
      );
    },
  });
};
